import React from "react";
import { Code, List, Stack, Text } from "@mantine/core";
import { Alert, spacePx } from "@xplatform/design-system";
import { useTranslation } from "react-i18next";
import { errorMessage } from "@hooks/monitoring/useApiResource";
import { errorCodeOf, fieldErrorsOf } from "@utils/mappingConfig";

/** An API error with its stable code and, for a 422, every field error by path. */
export const ApiErrorAlert: React.FC<{ error: unknown; title?: string }> = ({ error, title }) => {
  const { t } = useTranslation();
  const code = errorCodeOf(error);
  const fieldErrors = fieldErrorsOf(error);
  return (
    <Alert color="red" title={title ?? t("mappingConfig.errors.generic")}>
      <Stack gap="xs">
        <Text size="sm">{code ? t(`mappingConfig.errors.codes.${code}`, { defaultValue: errorMessage(error) }) : errorMessage(error)}</Text>
        {code && <Text size="xs" c="dimmed" ff="monospace">{code}</Text>}
        {fieldErrors.length > 0 && (
          <List size="sm" spacing={spacePx[1]}>
            {fieldErrors.map((e, i) => (
              <List.Item key={`${e.path}-${i}`}>
                <Code>{e.path}</Code> {e.message}
              </List.Item>
            ))}
          </List>
        )}
      </Stack>
    </Alert>
  );
};
